import axios from "axios";
import { responseStateMachine } from "../../utils/AxiosHelpers";
import { AXIOS_INSTANCE_CONFIG } from "../../utils/constants";
import { handleRequestHeaders } from "./headersManager";

const source = axios.CancelToken.source();

const instance = axios.create(AXIOS_INSTANCE_CONFIG);

instance.interceptors.request.use(
    (request) => {
        return handleRequestHeaders(request);
    },
    (error) => {
        Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (response) => {
        return responseStateMachine(response);
    },
    (error) => {
        if (error.status !== 401) {
            return Promise.reject(error);
        }
        // axios.interceptors.response.eject(interceptor);
        // return refreshToken();
    }
);

export { instance, source };
